import { Flex, ThemeIcon, Text } from '@mantine/core';
import { IconListSearch } from '@tabler/icons-react';

type RenderEmptyRowsFallbackProps = {
  desc?: string;
  subDesc?: string;
};

export const EmptyRowsFallback = ({
  desc = 'К сожалению, совпадений не найдено',
  subDesc = 'Попробуйте изменить параметры фильтров. Чтобы вернуться ко всему списку, сбросьте фильтр.',
}: RenderEmptyRowsFallbackProps) => {
  return (
    <Flex w='100%' p={16} gap={16} align='center'>
      <ThemeIcon bg='primary.0' size={32} radius='50%'>
        <IconListSearch size={24} color='var(--mantine-color-tertiary-7)' />
      </ThemeIcon>
      <Flex direction='column' gap={4}>
        <Text
          style={{
            fontWeight: '600',
          }}
          c='var(--mantinie-color-primary-4)'
        >
          {desc}
        </Text>
        <Text c='var(--mantinie-color-primary-4)'>{subDesc}</Text>
      </Flex>
    </Flex>
  );
};
